import React from 'react';
import { connect } from 'react-redux';
import BaseComponent from '../../../baseClasses/BaseComponent';

import UserAvatar from '../../../components/UserAvatar';
import UserAvatarWithInfo from '../../../components/UserAvatar/UserAvatarWithInfo';
import TaskActivity from '../TaskActivity';
import TaskInventory from '../TaskInventory';
import ViewAttachmentPopup from '../../../components/ViewAttachmentPopup';
import MultipleUserPopup from '../../../components/MultipleUserPopup/index';
import DocumentsList from '../../../components/TaskCRUD/DocumentsList';
import ExpandableSection from '../../../components/ExpandableSection';

import FileUtil from '../../../helpers/FileUtil/FileUtil';
import AnalyticsLogger from '../../../helpers/analytics/analyticsLogger';
import DataSource from '../../../dao/DataSource/DataSource';
import { task_complete } from '../../../dao/TasksDAO';

import expandor from '../../../assets/images/expandor.svg';
import contractor from '../../../assets/images/contractor.svg';

import './TaskDetails.scss';

/*
const taskDescriptor = {
  task: {
    completion_criteria: {
      attachments: {
        additionalFields: ["upload", "photo_longitude", "photo_latitude", "photo_taken_at"],
        conversions: {},
        user: {} 
      } ,
      comments: { user: {additionalFields: ["profile_image"] }},
      event_histories: { activity: {}, activity_sub_type: {}, user_who_performed_action: {} },
      form_fields: {}
    },
    reference_documents: {},
    user_task_assignments: {
      user: { additionalFields: ["profile_image"], 
        companies: {}
      }
    },
    build_owners: { companies: {} },
    inventory_items: {  inventory: {} },
    event_histories: { activity: {}, activity_sub_type: {}, user_who_performed_action: {} }
  }
}
*/

export class TaskDetails extends BaseComponent {

  constructor(props) {
    super(props);
    
    this.state = {
      menu: null,
      descriptionExpanded: true,
      activityExpanded: false,
      durationExpanded: true,
      setOriginalHeight: true,
      displayedUserInfo: null,
    };
    const currentRole = props.currentUser ? props.currentUser.role : null;
    this.analyticsLogger = new AnalyticsLogger({
      currentRole,
      isMobile: !!window.cordova,
    });
  }

  handleTaskUpdate(task, action, acData) {
    this.setState({ task });
  }

  componentDidMount() {
    super.componentDidMount(this);
    if (this.props.task) {
      this.taskDataSource = new DataSource('Task', this.props.task.id, task_complete, this.handleTaskUpdate);
      this.taskDataSource.get();
    }
  }

  componentWillUnmount() {
    if (this.taskDataSource) {
      this.taskDataSource.release();
    }
  }
  
  createMemberArray(userList, type) {
    if (userList) {
      return userList.map(user => {
        return <UserAvatar id={'user-avatar-task-settings-' + type + user.id} key={'user-avatar-task-settings' + user.id} user={user} />;
      });
    }
    else {
      return null;
    }
  }

  handleDescriptionClick() {
    if (!this.state.descriptionExpanded) {
      this.setState({ animateExpand: true });

    } else {
      this.setState({ animateContract: true });
    }
    this.setState({
      descriptionExpanded: !this.state.descriptionExpanded,
      animatedId: 'description',
    });
  }

  handleActivityClick() {
    this.setState({
      activityExpanded: !this.state.activityExpanded,
    });
  }

  handleFinishAnimation() {
    if (this.state.expanded && this.state.animateContract) {
      this.setState({
        animateContract: false,
        expanded: false,
        setOriginalHeight: false,
        animatedId: null,
      });
    }
    else {
      this.setState({
        animateExpand: false,
        setOriginalHeight: false,
        animatedId: null,
      });
    }
  }
  
  handleCloseAttachmentPopup() {
    this.setState({ reference_documentPopup: null });
  }

  handleDisplayReferenceDocument(referenceDoc) {
    const width = window.innerWidth - 300;
    const height = window.innerHeight - 190;
    const imageWidth = width;
    const imageHeight = height - 60;
    let reference_documentPopup = (
      <ViewAttachmentPopup
        attachment={referenceDoc}
        handlePopupClose={this.handleCloseAttachmentPopup}
        left={100}
        top={100}
        width={width}
        height={height}
        imageWidth={imageWidth}
        imageHeight={imageHeight}
      />
    );

    this.setState({ reference_documentPopup: reference_documentPopup });
    //log image download
    const extension = FileUtil.getExtension(referenceDoc.name);
    this.analyticsLogger.logRDLDownloadEvent(extension);
  }

  createReferenceDocList() {
    const { project } = this.props;
    const { task } = this.state;
    let allRefDocs = [];
    if (project && project.reference_documents) {
      for (let refDoc of project.reference_documents) {
        allRefDocs.push(refDoc);
      }
    }
    if (task.reference_documents) {
      for (let refDoc of task.reference_documents) {
        allRefDocs.push(refDoc);
      }
    }
    return (
      <ExpandableSection name="DOCUMENTS" initiallyExpanded={true}>
        <DocumentsList
          documentType='reference'
          documents={allRefDocs}
          parentComponentView={'task'}
        />
        {project &&
          <DocumentsList
            documentType='project'
            documents={project.unique_documents}
            parentComponentView={'task'}
          />
        }
      </ExpandableSection>
    );
  }

  handleCreateActivityList() {
    const { task } = this.state;
    return task ? <TaskActivity task={task} /> : null;
  }

  handleDisplayNotified() {
    this.setState({ displayNotified: true, displayedUserInfo: null });
  }

  handleDisplayAssignedTo() {
    this.setState({ displayAssignedTo: true, displayedUserInfo: null });
  }

  handleDisplayReviewer() {
    this.setState({ displayReviewer: true, displayedUserInfo: null });
  }

  handleDisplayApprover() {
    this.setState({ displayApprover: true, displayedUserInfo: null });
  }

  handleCloseNotified() {
    this.setState({ displayNotified: false });
  }

  handleCloseAssignedTo() {
    this.setState({ displayAssignedTo: false });
  }

  handleCloseReviewer() {
    this.setState({ displayReviewer: false });
  }

  handleCloseApprover() {
    this.setState({ displayApprover: false });
  }

  handleInfoOpen(assignment) {
    this.setState({ displayedUserInfo: assignment, displayNotified: false, displayAssignedTo: false, displayReviewer: false, displayApprover: false });
  }

  handleInfoClose() {
    this.setState({ displayedUserInfo: null });
  }

  handleDurationClick() {
    if (!this.state.durationExpanded) {
      this.setState({ animateExpand: true });

    } else {
      this.setState({ animateContract: true });
    }
    this.setState({
      durationExpanded: !this.state.durationExpanded,
      animatedId: 'duration',
    });
  }

  handleCreateTaskDuration(task) {
    const { project, projectTemplate, currentCompany } = this.props;
    if ((project && currentCompany.features && currentCompany.features.duration && currentCompany.features.duration.enabled &&
      project.config && project.config.duration) ||
      (projectTemplate && currentCompany.features && currentCompany.features.duration && currentCompany.features.duration.enabled &&
        projectTemplate && projectTemplate.config && projectTemplate.config.duration)) {
      const { task } = this.state;

      let durationText = 'This Task ';
      if (task.deadline_from_dependency) {
        durationText += 'should be completed ' + (task.deadline_from_dependency / 24) + ' day(s) after the previous task is completed.';
      }
      else {
        durationText += 'has no duration set and should be completed on the same day as the previous task.';
      }

      let durationIcon = expandor;
      if (this.state.durationExpanded) {
        durationIcon = contractor;
      }

      return <div className='task-duration-container'>
        <div className='task-duration-label'>
          Task Forecasting
          <img src={durationIcon} alt='expand' onClick={this.handleDurationClick} />
        </div>
        <div className={'task-duration ' + (this.state.durationExpanded ? '' : 'closed')}>
            <div className='task-duration-text'>{durationText}</div>
        </div>
      </div>;
    }
    else {
      return null;
    }
  }

  render() {
    const { inventoryItems, inventoryEnabled, project } = this.props;
    const { task } = this.state;

    if (!task) {
      return null;
    }

    let reviewerExists, approverExists, notifyExists, assignedToExists;
    let assignedToAvatar, notifiedAvatar, reviewerAvatar, approverAvatar;
    const notifiedUsers = [];
    const assignedUsers = [];
    const reviewerUsers = [];
    const approverUsers = [];
    
    if (task.user_task_assignments) {
      task.user_task_assignments.forEach(assignment => {
        switch (assignment.assignment_type) {
        case 'field_user':
          assignedToExists = true;
          assignedUsers.push(assignment.user);
          break;
        case 'reviewer':
          reviewerExists = true;
          reviewerUsers.push(assignment.user);
          break;
        case 'approver':
          approverExists = true;
          approverUsers.push(assignment.user);
          break;
        case 'notify':
          notifyExists = true;
          notifiedUsers.push(assignment.user);
          break;
        default:
          break;
        }
      });
    }

    if (notifiedUsers && notifiedUsers.length > 1) {
      notifiedAvatar = (
        <div>
          <UserAvatar handleSelected={this.handleDisplayNotified} extraLarge={true} multiAssigned={true} />
          <div className='assignment-label'>Notified</div>
          {this.state.displayNotified &&
            <MultipleUserPopup
              handleCloseClicked={this.handleCloseNotified}
              isMobile={false}
              title='Notified'
              users={notifiedUsers}
            />
          }
        </div>
      );
    }
    else if (notifiedUsers && notifiedUsers.length == 1) {
      notifiedAvatar = (
        <div key={notifiedUsers[0].id}>
          <UserAvatarWithInfo
            user={notifiedUsers[0]}
            extraLarge={true}
            handleInfoOpen={this.handleInfoOpen}
            handleInfoClose={this.handleInfoClose}
            assignment={'notify'}
            displayed={this.state.displayedUserInfo}
          />
          <div className='assignment-label'>Notified</div>
        </div>
      );
    }

    if (assignedUsers && assignedUsers.length > 1) {
      assignedToAvatar = (
        <div>
          <UserAvatar handleSelected={this.handleDisplayAssignedTo} extraLarge={true} multiAssigned={true} />
          <div className='assignment-label'>Assigned To</div>
          {this.state.displayAssignedTo &&
            <MultipleUserPopup
              handleCloseClicked={this.handleCloseAssignedTo}
              isMobile={false}
              title='Assigned To'
              users={assignedUsers}
            />
          }
        </div>
      );
    }
    else if (assignedUsers && assignedUsers.length == 1) {
      assignedToAvatar = (
        <div key={assignedUsers[0].id}>
          <UserAvatarWithInfo
            user={assignedUsers[0]}
            extraLarge={true}
            handleInfoOpen={this.handleInfoOpen}
            handleInfoClose={this.handleInfoClose}
            assignment={'assignedTo'}
            displayed={this.state.displayedUserInfo}
          />
          <div className='assignment-label'>Assigned to</div>
        </div>
      );
    }

    if (reviewerUsers && reviewerUsers.length > 1) {
      reviewerAvatar = (
        <div>
          <UserAvatar handleSelected={this.handleDisplayReviewer} extraLarge={true} multiAssigned={true} />
          <div className='assignment-label'>Reviewer</div>
          {this.state.displayReviewer &&
            <MultipleUserPopup
              handleCloseClicked={this.handleCloseReviewer}
              isMobile={false}
              title='Reviewer'
              users={reviewerUsers}
            />
          }
        </div>
      );
    }
    else if (reviewerUsers && reviewerUsers.length == 1) {
      reviewerAvatar = (
        <div key={reviewerUsers[0].id}>
          <UserAvatarWithInfo
            user={reviewerUsers[0]}
            extraLarge={true}
            handleInfoOpen={this.handleInfoOpen}
            handleInfoClose={this.handleInfoClose}
            assignment={'reviewer'}
            displayed={this.state.displayedUserInfo}
          />
          <div className='assignment-label'>Reviewer</div>
        </div>
      );
    }

    if (approverUsers && approverUsers.length > 1) {
      approverAvatar = (
        <div>
          <UserAvatar handleSelected={this.handleDisplayApprover} extraLarge={true} multiAssigned={true} />
          <div className='assignment-label'>Approver</div>
          {this.state.displayApprover &&
            <MultipleUserPopup
              handleCloseClicked={this.handleCloseApprover}
              isMobile={false}
              title='Approver'
              users={approverUsers}
            />
          }
        </div>
      );
    }
    else if (approverUsers && approverUsers.length == 1) {
      approverAvatar = (
        <div key={approverUsers[0].id}>
          <UserAvatarWithInfo
            user={approverUsers[0]}
            extraLarge={true}
            handleInfoOpen={this.handleInfoOpen}
            handleInfoClose={this.handleInfoClose}
            assignment={'approver'}
            displayed={this.state.displayedUserInfo}
          />
          <div className='assignment-label'>Approver</div>
        </div>
      );
    }

    let leftAssignment, middleAssignment, rightAssignment, notifyAssignment;
    let avatarStyles;

    // Ensure correct avatar ordering
    let userAvatars = [];
    if (assignedToExists) {
      userAvatars.push(assignedToAvatar);
    }
    if (reviewerExists) {
      userAvatars.push(reviewerAvatar);
    }
    if (approverExists) {
      userAvatars.push(approverAvatar);
    }
    if (notifyExists) {
      userAvatars.push(notifiedAvatar);
    }
    if (userAvatars.length == 1) {
      middleAssignment = userAvatars[0];
    }
    else {
      leftAssignment = userAvatars[0] || null;
      middleAssignment = userAvatars[1] || null;
      rightAssignment = userAvatars[2] || null;
      notifyAssignment = userAvatars[3] || null;
    }
    if (userAvatars.length == 4) {
      avatarStyles = { justifyContent: 'space-between' };
    }

    let descriptionIcon = expandor;
    let activityIcon = expandor;
    if (this.state.descriptionExpanded) {
      descriptionIcon = contractor;
    }

    let refDocs = this.createReferenceDocList();
    let activityList;
    if (this.state.activityExpanded) {
      activityIcon = contractor;
    }
    activityList = this.handleCreateActivityList();

    let taskDuration = this.handleCreateTaskDuration(task);

    return (
      // Replace with the appropriate HTML
      <div id={this.props.id} className="field-user-task-details">
        {this.state.reference_documentPopup}
        <div className="title">{this.textMap.taskDetails.toUpperCase()}</div>
        <div className="project-info">
          {project &&
            (task.user_task_assignments && task.user_task_assignments.length > 0 ?
              (<div className='user-avatars' style={avatarStyles}>
                <div className='assignment' style={notifyExists ? { marginLeft: '-13px' } : {}}>
                  {leftAssignment}
                </div>
                <div className='divider' />
                <div className='assignment'>
                  {middleAssignment}
                </div>
                <div className='divider' />
                <div className='assignment'>
                  {rightAssignment}
                </div>
                {/* Added two conditionals so not to mess up the space-between attribute for notfiy assignment */}
                {notifyAssignment && <div className='divider' />}
                {notifyAssignment &&
                  <div className='assignment' style={notifyExists ? { marginRight: '-17px' } : {}}>
                    {notifyAssignment}
                  </div>
                }
              </div>) :
              (<div className="no-assignments">No Task Assignments found. </div>))}
          
          <div className='horizontal-divider' />
          <div className='description-container'>
            <div className='description-label'>
              {this.textMap.description.toUpperCase()}
              <img src={descriptionIcon} alt='expand' onClick={this.handleDescriptionClick} />
            </div>
            <div className={'description ' + (this.state.descriptionExpanded ? '' : 'closed')}>
              {task.notes ?
                task.notes :
                <div className="description__empty">No Description found.</div>
              }
            </div>
          </div>

          {taskDuration ? <div className='horizontal-divider' /> : null}
          {taskDuration ? taskDuration: null}

          <div className='horizontal-divider' />
          <div className='ref-docs-container'>
            {refDocs}
          </div>

          {
            inventoryEnabled && project &&
            <TaskInventory items={inventoryItems || []} mobile={false} />
          }
          
          {project &&
            <div className='activity-container'>
              <div className='activity-label'>
                {this.textMap.activity.toUpperCase()}
                <img src={activityIcon} alt='expand' onClick={this.handleActivityClick} />
              </div>
              <div className={'activity ' + (this.state.activityExpanded ? '' : 'closed')} >
                {activityList ? activityList : <div style={{ color: '#2c2c2c' }}>No Activity found</div>}
              </div>
            </div>
          }
          {project &&
            <div className='horizontal-divider' />}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {

  return {
    currentCompany: state.new_companies.currentCompany,
    currentUser: state.new_users ? state.new_users.currentUser : null,
    permissions: state.new_users.permissions,
  };
};

export default connect(mapStateToProps)(TaskDetails);



// WEBPACK FOOTER //
// ./src/components/TaskCRUD/TaskDetails/index.js